import API from 'api/helpers/client';
import { IS_EC_RAIL } from 'helpers/rail';
import type {
  PaymentData,
  SetPaymentIntentParams,
  SetPaymentIntentResponse,
} from './payment.types';

export const getPaymentData = async (submissionId: string): Promise<PaymentData> => {
  const { data } = await API.get(`consumer-submission/${submissionId}/payment/`);

  return data;
};

/**
 * Enrol the customer in autopay for the intent they are about to confirm.
 *
 * The two rails address this differently, which is why the branch lives here rather than at the call site.
 * CC has a policy by this point, so it PATCHes a policy-scoped Stripe service route with no body. EC has no
 * policy until the payment succeeds — issuance is what the payment triggers — so it PATCHes the submission
 * itself and passes the intent id in the body, which the backend checks against the submission's account.
 *
 * The EC URL is written unprefixed on purpose: the axios interceptor rewrites `consumer-submission…` to
 * `ec/consumer-submission…` on the EC rail, exactly as it does for every other submission call.
 */
export const setPaymentIntent = async ({
  policyLocator,
  paymentIntentId,
  submissionId,
}: SetPaymentIntentParams): Promise<SetPaymentIntentResponse> => {
  if (IS_EC_RAIL) {
    const { data } = await API.patch(`consumer-submission/${submissionId}/payment/set-recurring/`, {
      payment_intent_id: paymentIntentId,
    });

    return data;
  }

  const { data } = await API.patch(
    `services/service-stripe/${policyLocator}/payment-intents/${paymentIntentId}`,
  );

  return data;
};
